import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const CircleChart = ({ value, total, color = "#4F46E5" }) => {
  const data = [
    { name: "Completed", value },
    { name: "Remaining", value: total - value },
  ];

  return (
    <div className="flex flex-col items-center justify-center">
      <PieChart width={100} height={100}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={40}
          outerRadius={50}
          startAngle={90}
          endAngle={-270}
          dataKey="value"
          stroke="none"
        >
          <Cell key="completed" fill={color} />
          <Cell key="remaining" fill="#E5E7EB" />
        </Pie>
      </PieChart>
      <div className="absolute flex items-center justify-center w-[100px] h-[100px]">
        <span className="text-xl font-bold text-gray-800">{value}</span>
      </div>
    </div>
  );
};

export default CircleChart;